module.exports = __webpack_public_path__ + "media/images/tour/zh-hans-844ebbc98e96581ce84bad14df81f61d.png";